<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="guestRefunds" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestRefundId"
  selectionMode="single" [(selection)]="guestRefund" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="showPaginator" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="fs-5" [class.small-text]="reservationId">Credit Authorization Acknowledgements</div>
      </div>
      <div>
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem; margin-right:10px;" (click)="reloadPage()">Clear
            Filters</button>
          }

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem;" (click)="onOpenFormAdd()"
          [class.small-btn]="reservationId">New Credit Auth Acknowledgement +</button>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        @if (col.condition) {
          <th [ngStyle]="{'width': 'auto'}">
            @if (col.sorting) {
              <span [pSortableColumn]="col.field">
                {{ col.header }}
                @if (!reservationId) {
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                }
              </span>
            } @else {
              {{ col.header }}
            }
          </th>
        }
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (!reservationId) {
      <tr>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestRefundId', 'in')"></th> -->
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.shortTermRentalId', 'in')"></th>
        }
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.propertyCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [options]="statuses" dropdownIcon="fa fa-caret-down" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Status" [style]="{'width':'100%'}" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
          (onChange)="pt.filter($event.value, 'status', 'in')"></p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'refundAmountTTL', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
          (onSelect)="onDateFilterChange('checkInDate', $event, pt)"></p-calendar>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
          (onSelect)="onDateFilterChange('checkOutDate', $event, pt)"></p-calendar>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
          (onSelect)="onDateFilterChange('submittedDate', $event, pt)"></p-calendar>
        </th>
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
            (onSelect)="onDateFilterChange('creditAuthSendDate', $event, pt)"></p-calendar>
          </th>
        }
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
            (onSelect)="onDateFilterChange('creditAuthRcvDate', $event, pt)"></p-calendar>
          </th>
        }
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
            (onSelect)="onDateFilterChange('acctRcvDate', $event, pt)"></p-calendar>
          </th>
        }
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
            (onSelect)="onDateFilterChange('acctProcessDate', $event, pt)"></p-calendar>
          </th>
        }
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar [dateFormat]="'yy-mm-dd'" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}" placeholder="YYYY-MM-DD"
            (onSelect)="onDateFilterChange('guestRcvFundsEstDate', $event, pt)"></p-calendar>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-guestRefund let-rowIndex="rowIndex">
    <tr [pSelectableRow]="guestRefund">
      <!-- <td>{{guestRefund.guestRefundId}} </td> -->
      <td>{{guestRefund?.lastName}}</td>
      @if (!reservationId) {
        <td>{{guestRefund?.shortTermRentalId}} </td>
      }
      <td>{{guestRefund?.propertyCode}}</td>
      <td>{{getStatusName(guestRefund)}}</td>
      <td>{{guestRefund?.refundAmountTTL | currency : 'USD' : 'symbol' :'1.0-0'}}</td>
      <td>{{guestRefund?.checkInDate | date}}</td>
      <td>{{guestRefund?.checkOutDate | date}}</td>
      <td>{{guestRefund?.submittedDate | date}}</td>
      @if (!reservationId) {
        <td>{{guestRefund?.creditAuthSendDate | date}}</td>
      }
      @if (!reservationId) {
        <td>{{guestRefund?.creditAuthRcvDate | date}}</td>
      }
      @if (!reservationId) {
        <td>{{guestRefund?.acctRcvDate | date}}</td>
      }
      @if (!reservationId) {
        <td>{{guestRefund?.acctProcessDate | date}}</td>
      }
      @if (!reservationId) {
        <td>{{guestRefund?.guestRcvFundsEstDate | date}}</td>
      }
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(guestRefund)">edit</mat-icon>
        </a>
        <a>
          <mat-icon style="color:#c0392b; font-size:110%; cursor:pointer;"
          (click)="onRowDelete(guestRefund)">delete</mat-icon>
        </a>
      </span>
    </td>
  </tr>
  @if (guestRefunds.length - 1 == rowIndex) {
    <tr>
      <!-- <td>{{guestRefund.guestRefundId}} </td> -->
      <td></td>
      @if (!reservationId) {
        <td></td>
      }
      <td></td>
      <td><strong>Total : </strong></td>
      <td>{{total | currency : 'USD' : 'symbol' :'1.0-0'}}</td>
      <td></td>
      <td></td>
      <td></td>
      @if (!reservationId) {
        <td></td>
      }
      @if (!reservationId) {
        <td></td>
      }
      @if (!reservationId) {
        <td></td>
      }
      @if (!reservationId) {
        <td></td>
      }
      @if (!reservationId) {
        <td></td>
      }
      <td></td>
    </tr>
  }
</ng-template>
</p-table>